import Container from "@/components/Container/Container";
import Button from "@/components/Button/Button";
import styles from "./NotFoundPage.module.css";

export default function NotFoundPage() {
  return (
    <section className={styles.wrapper}>
      <Container width="default" className={styles.inner}>
        <span className="eyebrow">404</span>
        <h1>This page can&rsquo;t be found.</h1>
        <p>
          The page you&rsquo;re looking for may have moved or no longer exists. Let&rsquo;s find
          you a way back.
        </p>
        <Button as="link" to="/" variant="primary" size="lg">
          Return home
        </Button>
      </Container>
    </section>
  );
}
